import React, { useState, useEffect, useRef } from "react";
import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import { login, verifyLoginOtp } from "../../controllers/accounts/Account";
import { notification } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InfoCircleOutlined } from "@ant-design/icons";
import { faEyeSlash, faEye} from '@fortawesome/free-solid-svg-icons';

const LoginPage = () => {
  const navigate = useNavigate();
  const inputRef = {
    email: useRef(null),
    password: useRef(null),
  };
  const ADMINDATA = JSON.parse(localStorage.getItem("ADMIN-INFO"));
  const TOKEN = localStorage.getItem("TOKEN");
  const [formData, setFormData] = useState({
    email: localStorage.getItem("LOGIN_EMAIL")
      ? atob(localStorage.getItem("LOGIN_EMAIL"))
      : "",
    password: localStorage.getItem("LOGIN_PASSWORD")
      ? atob(localStorage.getItem("LOGIN_PASSWORD"))
      : "",
  });
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [success, setSuccess] = useState("");

  const [countdown, setCountdown] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  /*************************************************************
   * Function Name  : handleChange
   * Purpose        : This function is used for store input value in states
   * Created Date   : 08-01-2024
   *************************************************************/
  const handleChange = (e) => {
    setFormData((preVal) => ({
      ...preVal,
      [e.target.name]: e.target.value,
    }));
    setErrors((...preError) => ({
      ...preError,
      [e.target.name]: "",
    }));
  }; //End of FUnction

  /*************************************************************
   * Function Name  : handleLogin
   * Purpose        : This function is used generate login OTP
   * Created Date   : 08-01-2024
   *************************************************************/
  const handleLogin = async () => {
    try {
      setIsLoading(true);
      if (!formData?.email) {
        setErrors((prevError) => ({
          ...prevError,
          email: "Email is required.",
        }));
        return;
      } else if (!formData.password) {
        setErrors((prevError) => ({
          ...prevError,
          password: "Password is required.",
        }));
        return;
      }

      const options = { email: formData?.email, password: formData.password };
      const result = await login(options);

      if (result.status === true) {
        setIsOTPSent(true);

        setSuccess((prevSuccess) => ({
          ...prevSuccess,
          formSuccess: result.message,
        }));
        setCountdown(60);
        setIsCounting(true);
      } else {
        setIsOTPSent(false);
        setErrors((prevError) => ({
          ...prevError,
          formError: result.message,
        }));
      }
    } catch (error) {
      console.error("Error during login process:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  /*************************************************************
   * Function Name  : handleVerifyOTP
   * Purpose        : This function is used handle verify otp
   * Created Date   : 08-01-2024
   *************************************************************/
  const handleVerifyOTP = async () => {
    try {
      setIsLoading(true);
      if (!formData?.email) {
        setErrors((...preError) => ({
          ...preError,
          email: "Email is required.",
        }));
      } else if (!formData.otp) {
        setErrors((...preError) => ({
          ...preError,
          otp: "One Time Password is required.",
        }));
      } else {
        // const web_device_id = await generateToken();
        const web_device_id = '';
        const options = {
          email: formData?.email,
          otp: formData.otp,
          ...(web_device_id ? { web_device_id: web_device_id } : null),
        };
        const result = await verifyLoginOtp(options);
        if (result.status === true) {
          if (formData?.remember_me && formData?.email && formData?.password) {
            // localStorage.setItem('LOGIN_EMAIL', btoa(formData?.email));
            // localStorage.setItem('LOGIN_PASSWORD', btoa(formData?.password));
          }
          navigate("/dashboard");
        } else {
          // setErrors((...preError) => ({
          //   ...preError,
          //   formError: "Somthing went wrong! Please try after some time.",
          // }));
          notification.open({
            message: "Opps!",
            description: `${result?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      setErrors((...preError) => ({
        ...preError,
        formError: "error",
      }));
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    } 
  }; //End of Function

  /*************************************************************
   * Function Name  : handleEmailChange
   * Purpose        : This function is used for change email id
   * Created Date   : 08-01-2024
   *************************************************************/
  const handleEmailChange = async () => {
    //Empty OTP Input Box
    setFormData((preVal) => ({
      ...preVal,
      password: "",
      otp: "",
    }));
    setIsOTPSent(false);
    setCountdown(0);
  }; //End of Function

  /*************************************************************
   * Purpose        : This hooks is used for handle otp sent countdown
   * Created Date   : 08-01-2024
   *************************************************************/
  useEffect(() => {
    if (ADMINDATA || TOKEN) {
      navigate("/dashboard");
    }
    let countdownInterval;
    if (isCounting) {
      countdownInterval = setInterval(() => {
        if (countdown > 0) {
          setCountdown((prevCountdown) => prevCountdown - 1);
        } else {
          clearInterval(countdownInterval);
          setIsCounting(false);
        }
      }, 1000);
    } else {
      clearInterval(countdownInterval);
    }
    return () => {
      clearInterval(countdownInterval);
    };
  }, [countdown, isCounting]);

  /*************************************************************
   * Purpose        : This hooks is used for handle key press on email input
   * Created Date   : 20-01-2024
   *************************************************************/
  // For Email
  const handleEmailKeyPress = (event) => {
    if (event.key === "Enter") {
      if (inputRef.password.current) {
        inputRef.password.current.focus();
      }
    }
  };

  
  //End of Function
  return (
    <div className="login-page-wrapper">
      <div className="login-card">
        <div className="login-logo-wrap">
          <img src="/logo.png" alt="Logo" />
        </div>

        {!isOTPSent && (
          <div className="step-block">
            <h2 className="login-title">Admin Login</h2>
            <p className="login-subtitle">Sign in to your account to continue</p>

            <div className="form-field">
              <label htmlFor="email">Email Address</label>
              <div className="field-input-wrap">
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="no-icon"
                  onKeyDown={handleEmailKeyPress}
                  onChange={handleChange}
                  value={formData?.email}
                  placeholder="you@example.com"
                  autoComplete="email"
                />
              </div>
              {errors?.email && <div className="field-error">{errors.email}</div>}
            </div>

            <div className="form-field">
              <label htmlFor="password">Password</label>
              <div className="field-input-wrap">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  onChange={handleChange}
                  ref={inputRef.password}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                />
                <button type="button" className="eye-btn" onClick={togglePasswordVisibility} tabIndex={-1}>
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
              {errors?.password && <div className="field-error">{errors.password}</div>}
            </div>

            <div className="form-footer-row">
              <Link to="/reset-password" className="link-red">Forgot Password?</Link>
            </div>

            {errors?.formError && (
              <div className="form-error-banner">{errors.formError}</div>
            )}

            <button
              type="button"
              className="login-btn"
              onClick={handleLogin}
              disabled={isLoading}
            >
              {isLoading && <span className="btn-spinner" />}
              {isLoading ? "Sending OTP…" : "Continue"}
            </button>

            <div className="form-footer-row" style={{ marginTop: "20px", justifyContent: "center" }}>
              <Link to="/agent-login" className="link-red">Agent Login</Link>
            </div>
          </div>
        )}

        {isOTPSent && (
          <div className="step-block">
            <h2 className="login-title">Verify OTP</h2>
            <p className="login-subtitle">Enter the one-time password sent to your email</p>

            {success?.formSuccess && (
              <div className="form-success-banner">
                {success.formSuccess}
                <Link to={false} onClick={handleEmailChange}>Change</Link>
              </div>
            )}

            <div className="form-field">
              <label htmlFor="otp">One-Time Password</label>
              <div className="field-input-wrap">
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  className="no-icon"
                  inputMode="numeric"
                  onChange={handleChange}
                  ref={inputRef.otp}
                  placeholder="Enter OTP"
                  autoComplete="one-time-code"
                  maxLength={6}
                />
              </div>
              {errors?.otp && <div className="field-error">{errors.otp}</div>}
            </div>

            <div className="resend-row">
              {isCounting ? (
                <span className="resend-countdown">
                  Resend OTP in <strong>{countdown}s</strong>
                </span>
              ) : (
                <button type="button" className="resend-link" onClick={handleLogin}>
                  Resend OTP
                </button>
              )}
              <Link to={false} onClick={handleEmailChange} className="link-red">
                Change email
              </Link>
            </div>

            <button
              type="button"
              className="login-btn"
              onClick={handleVerifyOTP}
              disabled={isLoading}
            >
              {isLoading && <span className="btn-spinner" />}
              {isLoading ? "Verifying…" : "Verify & Login"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
